
















































import { Vue, Component } from "vue-property-decorator";
import { Observer } from "mobx-vue";
import mapStore from "@/store/mapStore";
import formatDistanceToNow from "date-fns/formatDistanceToNow";

function isValidLatLng(truck: { latitude?: number; longitude?: number }) {
  return typeof truck.latitude === "number" && typeof truck.longitude === "number" && !isNaN(truck.latitude) && !isNaN(truck.longitude);
}

@Observer
@Component
class TruckMarkers extends Vue {
  // Provide $mq as a computed property for template compatibility
  get $mq(): string {
    // Vue automatically injects $mq if vue-mq is used; fallback to 'md' if not present
    return (this.$root as { $mq?: string }).$mq || "md";
  }
  mapStore = mapStore;
  formatDistanceToNow = formatDistanceToNow;
  get validTruckLocations() {
    const valid = this.mapStore.truckLocations.filter(isValidLatLng);
    return valid;
  }
}

export default TruckMarkers;
